// lib/audio-storage.ts — IndexedDB CRUD for audio blobs

const AUDIO_DB_NAME = 'actingapp-audio';
const AUDIO_STORE = 'clips';

export function openAudioDb() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(AUDIO_DB_NAME, 1);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(AUDIO_STORE)) {
                db.createObjectStore(AUDIO_STORE);
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function saveAudioBlob(id, blob) {
    const db = await openAudioDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(AUDIO_STORE, 'readwrite');
        tx.objectStore(AUDIO_STORE).put(blob, id);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

export async function getAudioBlob(id) {
    const db = await openAudioDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(AUDIO_STORE, 'readonly');
        const req = tx.objectStore(AUDIO_STORE).get(id);
        req.onsuccess = () => resolve(req.result || null);
        req.onerror = () => reject(req.error);
    });
}

export async function deleteAudioBlob(id) {
    const db = await openAudioDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(AUDIO_STORE, 'readwrite');
        tx.objectStore(AUDIO_STORE).delete(id);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}

export function createAudioId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'audio_' + Date.now() + '_' + Math.random().toString(16).slice(2);
}
